import {
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Tag,
} from "@chakra-ui/react";
import React, { useEffect, useMemo, useState } from "react";
import { FaPlus } from "react-icons/fa";
import {
  LocationViewModel,
  useAvailableTags,
  useSuggestTagMutation,
} from "../../data/occupancy.api";

type Props = {
  location?: LocationViewModel;
};

const SpaceTags = ({ location }: Props) => {
  const { data, isLoading, isError } = useAvailableTags(location?.key);
  const [tags, setTags] = useState<string[]>();
  const suggestTag = useSuggestTagMutation(location?.key);

  useEffect(() => {
    setTags(location?.tags);
  }, [location]);

  const availableTags = useMemo(() => {
    if (tags) {
      return data?.filter(
        (t) =>
          !tags.map((tag) => tag.toLowerCase()).includes(t.value.toLowerCase())
      );
    }
  }, [data, tags]);

  return tags ? (
    <Flex flexWrap="wrap" gap={1}>
      {tags.map((t) => (
        <Tag>{t}</Tag>
      ))}
      {!isError &&
      availableTags &&
      availableTags.length > 0 &&
      location?.locationPreferences.usersCanTag ? (
        <Menu size="sm">
          <MenuButton
            as={Button}
            isLoading={suggestTag.isLoading || isLoading}
            size="xs"
            leftIcon={<FaPlus />}
          >
            Add Tag
          </MenuButton>
          <MenuList maxH={400} overflowY="auto">
            {availableTags.map((tag) => (
              <MenuItem
                key={tag.key}
                onClick={async () => {
                  await suggestTag.mutateAsync(tag.key);
                  setTags((prev) => [...prev!, tag.value]);
                }}
              >
                {tag.value}
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
      ) : null}
    </Flex>
  ) : null;
};

export default SpaceTags;
